export default {
    search: 'Search',
    search_open: 'Click to Expand',

    not_selected: 'Not chosen',
    selected: 'Selected',
    select_value: 'Select a value',
    no_result: 'No matching results',
    no_options: 'There are no options to choose from',

    saved: 'Saved',
    deleted: 'Removed',
    delete: 'Delete',
    edit: 'Edit',
    empty_field: 'Required field is not filled',

    user: 'User',
    status: 'Status',
    date: 'Date',

    error: 'An error has occurred',
    success: 'Successfully',
    cancel: 'Close',
    close: 'Close',
    send: 'Send message',

    yes: 'Yes',
    no: 'Not',
    rejected: 'Rejected',

    confirm_action: 'Confirm Action',
    confirm_action_delete: 'Are you sure you want to delete the selected item?',
}
